/* Techniques redesign motion layer. Native scroll only; respects reduced motion. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const reveal = !reduce && document.documentElement.dataset.tcReveals !== 'off';

  // Split headlines marked .tc-lines into masked lines (authored as <span>line</span> children).
  document.querySelectorAll('.tc-lines').forEach((el) => {
    if (el.hasAttribute('data-tc-split') && window.Tc?.splitLines) { Tc.splitLines(el); return; }
    [...el.children].forEach((line, i) => {
      if (line.firstElementChild && line.firstElementChild.tagName === 'SPAN') return;
      const inner = document.createElement('span');
      inner.innerHTML = line.innerHTML;
      line.innerHTML = '';
      line.appendChild(inner);
      inner.style.setProperty('--tc-l', i);
    });
  });

  const targets = document.querySelectorAll('[data-tc-reveal], .tc-lines');
  if (!reveal || !('IntersectionObserver' in window)) {
    targets.forEach((t) => t.classList.add('is-in'));
  } else {
    // Masked elements are fully clipped at rest, which hides them from IntersectionObserver,
    // so we watch their parent and reveal the child.
    const owners = new Map();
    const io = new IntersectionObserver((entries) => {
      const batches = new Map();
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        (owners.get(e.target) || [e.target]).forEach((t) => {
          const group = t.closest('[data-tc-stagger]');
          // Only stagger siblings revealed in this frame. A lone phone card starts immediately.
          if (group) {
            const i = batches.get(group) || 0;
            t.style.setProperty('--tc-i', Math.min(i, 5));
            batches.set(group, i + 1);
          }
          t.classList.add('is-in');
        });
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    targets.forEach((t) => {
      const watch = t.dataset.tcReveal === 'mask' ? t.parentElement : t;
      if (!owners.has(watch)) owners.set(watch, []);
      owners.get(watch).push(t);
      io.observe(watch);
    });
  }

  // Remember which card image was clicked so the next page can morph from it.
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('a[href*="/products/"]');
    if (!a) return;
    const card = a.closest('.product-card, .tc-card');
    const img = card && card.querySelector('img');
    if (img) window.__tcLastImg = img;
  }, true);

  // Hero videos: play only while visible, never on reduced motion or data saver.
  const saveData = navigator.connection && navigator.connection.saveData;
  document.querySelectorAll('video[data-tc-autoplay]').forEach((v) => {
    if (v.dataset.tcMq && !window.matchMedia(v.dataset.tcMq).matches) return;
    if (reduce || saveData) return;
    const vio = new IntersectionObserver(([en]) => {
      if (en.isIntersecting) {
        if (v.dataset.src && !v.getAttribute('src')) {
          const go = () => { v.src = v.dataset.src; v.play().catch(() => {}); };
          document.readyState === 'complete' ? go() : window.addEventListener('load', () => setTimeout(go, 300), { once: true });
        }
        v.play().catch(() => {});
      } else { v.pause(); }
    }, { rootMargin: '200px 0px', threshold: 0.01 });
    vio.observe(v);
  });

  // Element parallax on [data-tc-parallax="0.1"]: transform only, desktop pointers only.
  const para = [...document.querySelectorAll('[data-tc-parallax]')];
  if (para.length && !reduce && window.matchMedia('(min-width: 750px)').matches) {
    let pt = false;
    const pu = () => {
      const vh = window.innerHeight;
      para.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        const off = (r.top + r.height / 2 - vh / 2);
        el.style.transform = `translate3d(0, ${(off * -parseFloat(el.dataset.tcParallax)).toFixed(1)}px, 0)`;
      });
      pt = false;
    };
    window.addEventListener('scroll', () => { if (!pt) { pt = true; requestAnimationFrame(pu); } }, { passive: true });
    pu();
  }

  // Parallax-lite on [data-tc-drift]: transform only, rAF-throttled.
  const drift = [...document.querySelectorAll('[data-tc-drift]')];
  if (drift.length && !reduce) {
    let ticking = false;
    const update = () => {
      const vh = window.innerHeight;
      drift.forEach((el) => {
        const r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        const p = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = `translate3d(0, ${(p * -parseFloat(el.dataset.tcDrift || 40)).toFixed(1)}px, 0) scale(1.08)`;
      });
      ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }
})();
